<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('ai_model.update_title') }}</span>
            <span v-else>{{ $t('ai_model.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('ai_model.name') }}</label>
          <b-form-input type="text" :placeholder="$t('ai_model.name_placeholder')"
            :class="{ 'is-invalid' : fErr('name') }"
            v-model="entity.name"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('config')">
          <label>{{ $t('ai_model.config') }}</label>
          <b-form-textarea type="text" :placeholder="$t('ai_model.config_placeholder')"
            :class="{ 'is-invalid' : fErr('config') }"
            rows="3" max-rows="6"
            v-model="entity.config"/>
        </b-form-group>
        <b-form-group v-if="isUpdateForm">
          <label>{{ $t('ai_model.labels') }}</label>
          <b-form-textarea type="text"
            rows="6" disabled v-model="entity.labels"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('file')">
          <label>{{ $t('ai_model.file') }}</label>
          <b-form-file
            v-model="entity.file"
            :class="{ 'is-invalid' : fErr('file') }"
            :placeholder="$t('ai_model.file_placeholder')"
            :drop-placeholder="$t('ai_model.file_drop_placeholder')"
          ></b-form-file>
        </b-form-group>

      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'AiModels' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';

import { mapGetters, mapState } from 'vuex';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
          config: '',
          file: null,
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },
  },
  methods: {
    getForUpdate: Services.aiModels.editData,
    getForCreate: Services.aiModels.createData,
    pushUpdate: Services.aiModels.update,
    pushCreate: Services.aiModels.create,
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.projectId, this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.aiModel : { ...this.entity, ...data.data.aiModel };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.projectId, { ...this.entity, project_id: this.projectId }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'ai_models')) {
          this.$router.push({ name: 'AiModelUpdate', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style scoped>
</style>
